export enum TablesDBIndexType {
    Key = 'key',
    Fulltext = 'fulltext',
    Unique = 'unique',
    Spatial = 'spatial',
}